import { render, staticRenderFns } from "./CounterControl.vue?vue&type=template&id=b97328c4&scoped=true&lang=pug&"
import script from "./CounterControl.vue?vue&type=script&lang=js&"
export * from "./CounterControl.vue?vue&type=script&lang=js&"
import style0 from "./CounterControl.vue?vue&type=style&index=0&id=b97328c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97328c4",
  null
  
)

component.options.__file = "CounterControl.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {
  VBtn,
})
